import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { Icon, IconEnum } from '@greenkub-fronts/shared/ui';
import { UiTheme } from '@greenkub-fronts/shared/interface';

export interface CustomerMenuContentProps {
  handleClickLink: () => void;
  currentTheme: UiTheme;
}

export function CustomerMenuContent(props: CustomerMenuContentProps) {
  const { handleClickLink, currentTheme } = props;

  return (
    <Fragment>
      <li className={cx('Menu-item', currentTheme)}>
        <Link to="/" onClick={() => handleClickLink()}>
          <Icon name={IconEnum.DASHBOARD} />
          <span>Dashboard</span>
        </Link>
      </li>
      <li className={cx('Menu-item', currentTheme)}>
        <Link to="/chat" onClick={() => handleClickLink()}>
          <Icon name={IconEnum.CONVERSATION_NOTIF} />
          <span>Chat</span>
        </Link>
      </li>
      <li className={cx('Menu-item', currentTheme)}>
        <Link to="/document" onClick={() => handleClickLink()}>
          <Icon name={IconEnum.ESPACE_DOCUMENTAIRE} />
          <span>Mes documents</span>
        </Link>
      </li>
      <li className={cx('Menu-item')}>
        <Link to="/anciens-projets" onClick={() => handleClickLink()}>
          <Icon name={IconEnum.DASHBOARD} />
          <span>Mes anciens projets</span>
        </Link>
      </li>
    </Fragment>
  );
}

export default CustomerMenuContent;
